import React from 'react';
import defaultRenderEmpty from 'antd/es/config-provider/defaultRenderEmpty';
import cls from 'classnames';
import intl from 'react-intl-universal';

import styles from './index.module.scss';

interface EmptyRender {
  (): React.ReactNode;
}

interface IEmptyProps {
  className?: string;
  hintText?: string;
}
export const EmptyHint: React.FC<IEmptyProps> = (props) => {
  const { className, hintText } = props;
  return (
    <div className={cls(styles.emptyHintWrapper, className)}>
      <div className="empty-hint-image" />
      <div className="empty-hint-text">{hintText || intl.get('app_no_data')}</div>
    </div>
  );
};

const TableRender: EmptyRender = () => {
  return <EmptyHint className={styles.tableEmptyWrapper} hintText={intl.get('app_no_data')} />;
};

const componentEmptyRender: {
  [name: string]: EmptyRender;
} = {
  Table: TableRender,
};

const main: (name: string) => React.ReactNode = (name) => {
  const render = componentEmptyRender[name];
  if (typeof render === 'function') {
    return render();
  }
  // 组件没有自定义空状态时 使用组件库默认的
  return defaultRenderEmpty(name);
};

export default main;
